// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unitsInfo__aVjGN {
  grid-column: 3;
}
@media (max-width: 1300px) {
  .unitsInfo__aVjGN {
    grid-column: 1/3;
  }
}

.unitsInfoTitle___8v9Y {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.unitsInfoFields__w3evN {
  height: calc(100% - 24px);
  margin-top: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.tabFieldsWrapper__pdtLS {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
}
@media (max-width: 1300px) {
  .tabFieldsWrapper__pdtLS {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 25px;
  }
}

.unitsInfoFieldsCustom__wApJA {
  display: grid;
  grid-template-columns: repeat(3, 225px);
  grid-column-gap: 24px;
}
@media (max-width: 1720px) {
  .unitsInfoFieldsCustom__wApJA {
    grid-template-columns: repeat(2, 225px);
  }
}
@media (max-width: 940px) {
  .unitsInfoFieldsCustom__wApJA {
    grid-template-columns: none;
  }
}

.skeletonField__I6pW8 {
  height: 39px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Profile/components/DataUnitsInfo/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,cAAA;AAzEF;AA2EE;EAHF;IAII,gBAAA;EAxEF;AACF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AAxEF;;AA2EA;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,qDAAA;EACA,wCAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAxEF;AA0EE;EALF;IAMI,aAAA;IACA,8BAAA;IACA,gBAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,uCAAA;EACA,qBAAA;AAvEF;AAwEE;EAJF;IAKI,uCAAA;EArEF;AACF;AAsEE;EAPF;IAQI,2BAAA;EAnEF;AACF;;AAsEA;EACE,YAAA;AAnEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.unitsInfo {\n  grid-column: 3;\n\n  @media (max-width: 1300px) {\n    grid-column: 1/3;\n  }\n}\n\n.unitsInfoTitle {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.unitsInfoFields {\n  height: calc(100% - 24px);\n  margin-top: 10px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.tabFieldsWrapper {\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n\n  @media (max-width: 1300px) {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 25px;\n  }\n}\n\n.unitsInfoFieldsCustom {\n  display: grid;\n  grid-template-columns: repeat(3, 225px);\n  grid-column-gap: 24px;\n  @media (max-width: 1720px) {\n    grid-template-columns: repeat(2, 225px);\n  }\n  @media (max-width: 940px) {\n    grid-template-columns: none;\n  }\n}\n\n.skeletonField {\n  height: 39px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unitsInfo": `unitsInfo__aVjGN`,
	"unitsInfoTitle": `unitsInfoTitle___8v9Y`,
	"unitsInfoFields": `unitsInfoFields__w3evN`,
	"tabFieldsWrapper": `tabFieldsWrapper__pdtLS`,
	"unitsInfoFieldsCustom": `unitsInfoFieldsCustom__wApJA`,
	"skeletonField": `skeletonField__I6pW8`
};
module.exports = ___CSS_LOADER_EXPORT___;
